<template>
    <d2-container :filename="filename">
        <!--<template slot="header">博客列表</template>-->
        <d2-crud :columns="columns" :data="data" :loading="loading" :rowHandle="rowHandle" :pagination="pagination"
            :options="options" title="博客列表" @row-remove="handleCustomDelete">
            <el-button slot="headerButton" @click="addBlog">
                <d2-icon name="plus"></d2-icon>
            </el-button>
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>
        <template slot="footer">
        </template>
    </d2-container>
</template>

<script>

import BlogView from "@/pages/components/blogView.vue"
import BlogEditor from "@/pages/components/blogEditor.vue"

export default {
    components: { BlogView, BlogEditor },
    data() {
        return {
            filename: __filename,
            loading: false,
            columns: [
                {
                    title: 'ID',
                    key: 'id',
                    fixed: true,
                    width: '50'
                },
                {
                    title: '缩略图',
                    key: 'img',
                    component: {
                        render: function (h, row) {
                            return h("img", {
                                attrs: {
                                    src: "//cdn.heanny.cn/Blog/" + row.img + '?d',
                                    height: '60px',
                                    width: '100px',
                                }
                            })
                        }
                    },
                    width: '110'
                },
                {
                    title: '标题',
                    key: 'title',
                },
                {
                    title: '标签',
                    key: 'tags',
                    width: '180'
                },
                {
                    title: '用户',
                    key: 'user',
                    width: '80'
                },
                {
                    title: '置顶',
                    key: 'top',
                    formatter(row, index, val) {
                        if (val === 1) {
                            return '置顶'
                        } else {
                            return '未置顶'
                        }
                    },
                    width: '70'
                },
                {
                    title: '加密',
                    key: 'encryption',
                    formatter(row, index, val) {
                        if (val === 1) {
                            return '加密'
                        } else {
                            return '未加密'
                        }
                    },
                    width: '70'
                },
                {
                    title: '阅读',
                    key: 'view',
                    width: '70'
                },
                {
                    title: '预览',
                    key: 'view',
                    component: {
                        render: function (h, row) {
                            return h(BlogView, {
                                attrs: {
                                    row: row
                                }
                            })
                        }
                    },
                    width: '70'
                },
                {
                    title: '编辑',
                    key: 'view',
                    component: {
                        render: function (h, row) {
                            return h(BlogEditor, {
                                attrs: {
                                    row: row
                                }
                            })
                        }
                    },
                    width: '70'
                }
            ],
            options: {
                stripe: true
            },
            data: [],
            pagination: {
                pageSize: 10,
                layout: 'prev, pager, next, total'
            },
            rowHandle: {
                columnHeader: '删除',
                remove: {
                    text: '',
                    icon: 'el-icon-delete',
                    size: 'small',
                    fixed: 'right',
                    confirm: true,
                },
                width: '70'
            },
        }
    }, methods: {
        handleCustomEvent({ index, row }) {
            this.$store.dispatch('d2admin/page/open', {
                name: 'blog-change',
            })
            location.href = '/#/blog/change/' + row.id
        },
        handleCustomDelete({ index, row }, done) {
            this.$request({ url: 'blog/delete', method: 'post', data: { id: row.id } }).then(res => {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                done()
            }).catch(err => {
                this.$message.error('删除失败');
            })
        },
        addBlog() {
            this.$store.dispatch('d2admin/page/open', {
                name: 'blog-add',
            })
            location.href = '/#/blog/add'
        },
        getData() {
            const _this = this
            this.loading = true
            this.$request({ url: 'blog/list' }).then(res => {
                _this.data = res
                _this.loading = false
            }).catch((error) => {
                this.msg = error
                _this.data = []
                _this.loading = false
            })

        },
    },
    created: function () {
        this.getData();
    }
}
</script>
